import { render, staticRenderFns } from "./multi_choices_with_childs.vue?vue&type=template&id=54ce2d32"
import script from "./multi_choices_with_childs.js?vue&type=script&lang=js&external"
export * from "./multi_choices_with_childs.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports